import { render } from "./ConsultingSvg.vue?vue&type=template&id=a928d7c2"
import script from "./ConsultingSvg.vue?vue&type=script&lang=js"
export * from "./ConsultingSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__